import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CampusContactType } from 'src/app/shared/enums/campus-contact-type.enum';
import { ContactComponentType } from 'src/app/shared/enums/contact-component-type.enum';
import { CampusContactEditor } from 'src/app/shared/models/campus-contact-editor.model';
import { Contact, IContactService } from 'src/app/shared/models/contact.model';

@Component({
    selector: 'app-campus-principal-dialog',
    templateUrl: './campus-principal-dialog.component.html',
    styleUrls: ['./campus-principal-dialog.component.scss'],
    standalone: false
})
export class CampusPrincipalDialogComponent {

  campusId: number;
  campusName: string;
  service: IContactService;
  principal: Contact;
  contactList: Contact[] = [];
  campusContact = new CampusContactEditor();

  constructor(
    private dialogRef: MatDialogRef<CampusPrincipalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data != null) {
      this.campusId = data.campusId;
      this.campusName = data.campusName;
      this.service = data.service;
      this.principal = data.principal;
      this.contactList = data.contactList || [];

      this.configData();
    }
  }

  configData() {
    this.campusContact.campusId = this.campusId;
    this.campusContact.campusContactId = this.principal ? this.principal.id : 0;
    this.campusContact.campusContactName = this.principal ? `${this.principal.firstName} ${this.principal.lastName}` : '';
    this.campusContact.service = this.service;
    this.campusContact.contactComponentType = ContactComponentType.CampusContact;
    this.campusContact.campusContactType = CampusContactType.Principal;
    this.campusContact.editMode = true;
    this.campusContact.disabledContactType = true;
    this.campusContact.contactList = this.contactList;
    this.campusContact.contact = this.principal || null;
  }

  cancelEdit() {
    this.dialogRef.close();
  }
  saveEdit(contact: Contact) {  
    this.dialogRef.close({ principal: contact });     
  }

  updateContact(contact: Contact) {
    this.dialogRef.close({ principal: contact });
  }
}
